import Vue from 'vue';
import GraphqlIntrospection from '@/store/graphql-introspection';
import profile from '@/store/profile';
import entity from '@/store/entity';
// eslint-disable-next-line import/no-cycle
import directory from '@/store/directory';
// eslint-disable-next-line import/no-cycle
import templates from '@/store/templates';
import Vuex, { Store } from 'vuex';
import { RootState } from '@/store/types';

Vue.use(Vuex);

const store: Store<RootState> = new Vuex.Store({
  state: {
    app: 'pimcore-vue',
  },
  modules: {
    profile,
    entity,
    directory,
    templates,
    graphQLIntrospection: GraphqlIntrospection,
  },
});

export default store;
